import React from "react";
import { Box, Table, TableBody, useMediaQuery, useTheme } from "@mui/material";
import {
  CsvImportPerformAttributesTypeEnum,
  CsvRow,
} from "@rentablo/api/apiv3";
import { useInfiniteScroll } from "@hooks";
import { DepotsRowHeadings } from "../head/DepotsRowHeadings";
import { DepotsParsedRow } from "../rows/DepotsParsedRow";
import { AccountsParsedRow } from "../rows/AccountsParsedRow";
import { AccountsRowHeadings } from "../head/AccountsRowHeadings";

type Props = {
  type: CsvImportPerformAttributesTypeEnum;
  images?: Record<string, string | null | undefined>;
  sortedResults: CsvRow[];
  sortField?: string;
  sortDirection?: TableSortDirection;
  sort: (field: string) => void;
  onEditClick: (result: CsvRow) => void;
  onDeleteClick: (result: CsvRow) => void;
  onEdit: (result: CsvRow) => void;
};

export const ParsingResultsTable = ({
  type,
  images,
  sortedResults,
  sortField,
  sortDirection,
  sort,
  onEditClick,
  onDeleteClick,
  onEdit,
}: Props) => {
  const isCashTransactions = type === "cash_transaction";
  const theme = useTheme();
  const isDownSM = useMediaQuery(theme.breakpoints.down("sm"));
  const {
    visibleData: visibleResults,
    scrollContainerRef,
    handleScroll,
  } = useInfiniteScroll(sortedResults);
  const getImage = (result: CsvRow) =>
    "isin" in result ? images?.[result.isin?.value ?? ""] : null;

  return (
    <Box
      sx={{
        borderRadius: `8px`,
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.border.primary}`,
        overflow: "hidden",
      }}
    >
      <Box
        ref={scrollContainerRef}
        onScroll={handleScroll}
        sx={{
          overflowY: "auto",
          maxHeight: isDownSM ? "calc(100vh - 341px)" : "calc(100vh - 280px)",
          "& tr:last-of-type .MuiTableCell-root": {
            borderBottom: "none !important",
          },
        }}
        height="100%"
      >
        <Table stickyHeader>
          {!isCashTransactions ? (
            <DepotsRowHeadings
              sortField={sortField}
              sortDirection={sortDirection}
              sort={sort}
            />
          ) : (
            <AccountsRowHeadings
              sortField={sortField}
              sortDirection={sortDirection}
              sort={sort}
            />
          )}
          <TableBody>
            {visibleResults.map((result) =>
              !isCashTransactions ? (
                <DepotsParsedRow
                  parsingResult={result}
                  key={result.id}
                  image={getImage(result)}
                  onEditClick={onEditClick}
                  onDeleteClick={onDeleteClick}
                />
              ) : (
                <AccountsParsedRow
                  row={result}
                  key={result.id}
                  onEditClick={onEditClick}
                  onDeleteClick={onDeleteClick}
                  onEdit={onEdit}
                />
              )
            )}
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
};
